import styled, { css } from 'styled-components'
import { colors, derivedColors } from '../../const'
import { withDisabledButtonStyled } from '../../const/styles'

const getButtonColor = (color) => {
  if (color === 'primary') return colors.surface
  if (color === 'error') return colors.surface
  return colors.primary
}

const getButtonBackground = (color) => {
  if (color === 'primary') return colors.primary
  if (color === 'secondary') return derivedColors.transparentSecondary
  if (color === 'error') return colors.error
  return colors.surface
}

const getButtonHoverBackground = (color) => {
  if (color === 'primary') return colors.primaryHover
  if (color === 'secondary') return derivedColors.transparentSecondaryHover
  if (color === 'error') return derivedColors.errorHover
  return colors.surface
}

export const Container = styled.button(
  ({ color }) => css`
    align-items: center;
    background-color: ${getButtonBackground(color)};
    border: none;
    border-radius: 6px;
    color: ${getButtonColor(color)};
    cursor: pointer;
    display: flex;
    font-family: 'Inter';
    font-size: 0.875rem;
    font-weight: 500;
    height: 40px;
    justify-content: center;
    min-width: 112px;
    padding: 0 12px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${getButtonHoverBackground(color)};
    }

    ${withDisabledButtonStyled}
  `
)
